import WidgetGroups from "@insite/client-framework/Types/WidgetGroups";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import StoreRetailModeSettingsView from "@store/Components/Store/StoreRetailModeSettingsView";
import { WIDGET_GROUP } from "@store/constants";
import { RetailModeSettingsPageContext } from "@store/Pages/RetailModeSettingsPage";
import * as React from "react";

interface Props extends WidgetProps {}

const RetailModeSettingsView: React.FunctionComponent<Props> = (props: Props) => {
    return <StoreRetailModeSettingsView />;
};

const widgetModule: WidgetModule = {
    component: RetailModeSettingsView,
    definition: {
        group: WIDGET_GROUP.retailMode as any,
        displayName: "Retail Mode Settings View",
        icon: "folder-bookmark",
        allowedContexts: [RetailModeSettingsPageContext] as any[],
    },
};

export default widgetModule;
